import { Dispatch, PropsWithChildren, SetStateAction, useCallback } from 'react';
import { createContext, useContext, useEffect, useState } from 'react';
import { getAccreditorRules, getAccreditors } from '../data/accreditorRules';
import { IAccreditorRule } from '../types/IAccreditor';
import { IApiContext } from '../types/Shared';
import { useAuthenticationContext } from './authenticationprovider';
export const AccreditorRulesContext = createContext<IAccreditationRulesContext>({ Pending: true, SetRefreshFlag: () => {} });
export function useAccreditationRulesContext() {
    return useContext(AccreditorRulesContext);
}

export interface IAccreditationRulesContext extends IApiContext<IAccreditorRule[]>
{
    SetRefreshFlag: Dispatch<SetStateAction<boolean>>;
}

export function AccreditationRulesProvider({ children }: PropsWithChildren<{}>) {

    const [rules, setRules] = useState<IAccreditorRule[]>();
    const [error, setError] = useState<string>();
    const [pending, setPending] = useState(true);
    const [refreshFlag, setRefreshFlag] = useState(false);
    const authContext = useAuthenticationContext();

    const getAccreditationRulesResult = async () => {
        try
        {                        
            const currentUserAccreditorCompanyName = authContext.Result?.KeplerAuthStatus.idTokenClaims.companyName;            
            if(currentUserAccreditorCompanyName)
            {       
                const accreditors = await getAccreditors();
                const accreditor = accreditors.find(accreditor => accreditor.AccreditorName.toLowerCase() === currentUserAccreditorCompanyName.toLowerCase());
                if(accreditor)
                {
                    const rules = await getAccreditorRules(accreditor);
                    return rules;
                }
            }   
            return [];   
        }
        catch(err: any) {
            throw err.message || err;
        }  
    };

    useEffect(() => {
        setError(undefined);
        setPending(true);
        getAccreditationRulesResult().then(res => {
            setRules(res);
        }).catch(err => {
            setPending(false);
            setError(err);
        })
    }, [authContext.Result, refreshFlag]);
    return (
        <AccreditorRulesContext.Provider value={{ Error: error, Pending: pending, Result: rules, SetRefreshFlag: setRefreshFlag }}>
            {children}
        </AccreditorRulesContext.Provider>
    );
}